import { render, staticRenderFns } from "./order_list.vue?vue&type=template&id=a356e626&scoped=true"
import script from "./order_list.vue?vue&type=script&lang=js"
export * from "./order_list.vue?vue&type=script&lang=js"
import style0 from "./order_list.vue?vue&type=style&index=0&id=a356e626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a356e626",
  null
  
)

export default component.exports